<template>
  <header class="navbar-wrap">
    <nav class="navbar section-container">
      <a class="brand" href="#home" @click="closeMenu">
        <img
          src="@/assets/abercodelogo.png"
          alt="Abercode"
          decoding="async"
          fetchpriority="high"
        />
      </a>

      <button
        class="menu-toggle"
        :class="{ active: isMenuOpen }"
        type="button"
        aria-label="Buka menu navigasi"
        @click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul class="nav-links" :class="{ show: isMenuOpen }">
        <li v-for="item in navItems" :key="item.href">
          <a :href="item.href" @click="closeMenu">{{ item.label }}</a>
        </li>
        <li>
          <a href="#contactdetails" class="btn btn-accent nav-cta" @click="closeMenu">
            Hubungi Kami
          </a>
        </li>
      </ul>
    </nav>

    <button
      v-if="isMenuOpen"
      class="mobile-overlay"
      type="button"
      aria-label="Tutup menu"
      @click="closeMenu"
    ></button>
  </header>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      isMenuOpen: false,
      navItems: [
        { label: "Beranda", href: "#home" },
        { label: "Layanan", href: "#services" },
        { label: "Cara Kerja", href: "#howitworks" },
        { label: "Portofolio", href: "#portofolio" },
        { label: "Tentang Kami", href: "#aboutus" },
      ],
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
.navbar-wrap {
  position: fixed;
  inset: 0 0 auto;
  z-index: 50;
  backdrop-filter: blur(8px);
  background: rgba(247, 250, 254, 0.84);
  border-bottom: 1px solid rgba(13, 77, 164, 0.12);
}

.navbar {
  min-height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.brand {
  display: inline-flex;
  align-items: center;
}

.brand img {
  width: 176px;
  height: auto;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
}

.nav-links a {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0 14px;
  border-radius: 999px;
  color: #1d2a4c;
  font-size: 0.94rem;
  font-weight: 600;
  transition: color 0.2s ease, background 0.2s ease;
}

.nav-links a:hover {
  color: var(--primary);
  background: rgba(13, 77, 164, 0.08);
}

.nav-links .nav-cta {
  min-height: 42px;
  padding: 10px 16px;
  color: #fff;
}

.menu-toggle {
  display: none;
  position: relative;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(13, 77, 164, 0.14);
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}

.menu-toggle span {
  position: absolute;
  left: 10px;
  width: 20px;
  height: 2px;
  background: var(--primary-strong);
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.menu-toggle span:nth-child(1) {
  top: 13px;
}

.menu-toggle span:nth-child(2) {
  top: 19px;
}

.menu-toggle span:nth-child(3) {
  top: 25px;
}

.menu-toggle.active span:nth-child(1) {
  transform: translateY(6px) rotate(45deg);
}

.menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.menu-toggle.active span:nth-child(3) {
  transform: translateY(-6px) rotate(-45deg);
}

.mobile-overlay {
  display: none;
}

@media (max-width: 900px) {
  .menu-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  .nav-links {
    position: fixed;
    top: calc(var(--header-height) - 4px);
    right: 16px;
    left: 16px;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding: 14px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 16px;
    background: #fff;
    box-shadow: var(--shadow-soft);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-8px);
    transition: opacity 0.25s ease, transform 0.25s ease;
    z-index: 2;
  }

  .nav-links.show {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }

  .nav-links a {
    min-height: 44px;
    padding: 0 12px;
  }

  .nav-links .nav-cta {
    width: 100%;
  }

  .mobile-overlay {
    position: fixed;
    inset: 0;
    z-index: 1;
    display: block;
    border: 0;
    margin: 0;
    padding: 0;
    background: rgba(11, 26, 59, 0.28);
  }
}
</style>
